var JumpLink = (function () {
    var config = {
        dropdownTrigger: '#jumpLinkContainer .dropdown-trigger',
        dropdownTriggerIcon: '#jumpLinkContainer .dropdown-trigger .icon',
        dropdownContent: '#jumpLinkContainer .dropdown-content',
        dropdownLinks: '#jumpLinkContainer .dropdown-content a',
        dropdownSelectedText: '#jumpLinkContainer .dropdown-trigger .text',
        dropdown: '#jumpLinkContainer #jumplinkDropdown',
        jumpLinks: '#jumpLinkContainer #jumpLinkNav a',
        jumpLinkNav: '#jumpLinkContainer #jumpLinkNav',
        jumpLinkContainer: '#jumpLinkContainer',
        mobileMaxWidth: 767,
        maxJumpLinkHeight: 30,
        resizeTimeout: null,
        scrollTimeout: null,
        scrollNoSectionTimeout: null,
        stickyClass: 'sticky',
    };

    //constructor
    function JumpLink() { }

    JumpLink.prototype.init = function () {
        var self = this;

        //dropdown click event
        $(config.dropdownTrigger).on('click', function (e) {
            self.handleDropdownClick(e);
        });

        //dropdown links click event
        $(config.dropdownLinks).on('click', function (e) {
            self.handleDropdownLinkClick(e, this);
        });

        //window click event
        $(window).on('click', function (e) {
            self.closeDropdown(e);
        });

        //jump links click event
        $(config.jumpLinks).on('click', function (e) {
            self.handleJumpLinkClick(e, this);
        });

        //show hide jumplinks and dropdown
        if ($(window).width() > config.mobileMaxWidth) {
            self.showHideJumpLinks();
        }

        //resize event
        $(window).on('resize', function () {
            //clear timeout
            clearTimeout(config.resizeTimeout);

            //set timeout
            config.resizeTimeout = setTimeout(function () {
                self.showHideJumpLinks();
            }, 400);
        });

        //scroll event
        $(window).on('scroll', function () {
            //clear timeout
            clearTimeout(config.scrollTimeout);

            //set timeout
            config.scrollTimeout = setTimeout(function () {
                self.addRemoveSticky();
                self.handleScrollBehavior();
            }, 100);
        });
    };

    JumpLink.prototype.addRemoveSticky = function () {
        var container = $(config.jumpLinkContainer);
        var jumpLinkContainerOffset = container.offset().top;
        var scrollPosition = $(window).scrollTop();
        var jumpLinkNav = $(config.jumpLinkNav);
        var dropdown = $(config.dropdown);

        if (scrollPosition > jumpLinkContainerOffset) {
            jumpLinkNav.addClass(config.stickyClass);
            dropdown.addClass(config.stickyClass);
        } else {
            jumpLinkNav.removeClass(config.stickyClass);
            dropdown.removeClass(config.stickyClass);
        }
    };

    JumpLink.prototype.handleScrollBehavior = function (e) {
        var links = document.querySelectorAll(config.jumpLinks);
        var arrayOfLinksIds = [];
        var dropdownLinks = document.querySelectorAll(config.dropdownLinks);

        links.forEach(function (e) {
            arrayOfLinksIds.push(e.getAttribute("href"));
        });

        var observer = new IntersectionObserver(
            function (entries) {
                clearTimeout(config.scrollNoSectionTimeout);
                config.scrollNoSectionTimeout = setTimeout(function () {
                    var isIntersecting = entries.find(function (e) {
                        return e.isIntersecting;
                    });
                    //if (!isIntersecting) {
                    //  $(config.dropdownSelectedText).text('');
                    //}
                }, 300);

                var intersectionSections = entries.filter(function (e) {
                    if (e.isIntersecting) return e;
                });

                if (intersectionSections.length === 0) {
                    links.forEach(function (link) {
                        link.classList.remove('active');
                    });
                } else {
                    var index = Array.prototype.slice
                        .call(arrayOfLinksIds)
                        .indexOf('#' + intersectionSections[0].target.id);

                    links.forEach(function (link) {
                        link.classList.remove('active');
                    });
                    links[index].classList.add('active');

                    var selectedText = $(dropdownLinks[index]).text();
                    $(config.dropdownSelectedText).text(selectedText);
                }
            },
            {
                rootMargin: '15% 0% 0% 0%',
                threshold: 1,
            }
        );

        arrayOfLinksIds.forEach(function (sectionId) {
            observer.observe(document.getElementById(sectionId.substring(1)));
        });
    };

    JumpLink.prototype.handleDropdownClick = function (e) {
        $(config.dropdownContent).toggleClass('show');
        $(config.dropdownTriggerIcon).toggleClass('rotate');
        e.stopPropagation();
    };

    JumpLink.prototype.handleDropdownLinkClick = function (event, elem) {
        var selectedText = $(elem).text();
        $(config.dropdownSelectedText).text(selectedText);
        this.adjustScroll(event, elem);
    };

    JumpLink.prototype.closeDropdown = function (e) {
        if (!$(config.dropdownTrigger).is(e.target)) {
            $(config.dropdownContent).removeClass('show');
        }
    };

    JumpLink.prototype.handleJumpLinkClick = function (event, elem) {
        $(config.jumpLinks).removeClass('active');
        $(elem).addClass('active');
        this.adjustScroll(event, elem);
    };

    JumpLink.prototype.showHideJumpLinks = function () {
        var self = this;

        $(config.jumpLinkNav).removeClass(config.stickyClass);
        $(config.dropdown).removeClass(config.stickyClass);

        $(config.jumpLinkNav).show();
        var jumpLinkHeight = $(config.jumpLinkNav).height();

        if (jumpLinkHeight > config.maxJumpLinkHeight) {
            $(config.dropdown).show();
            $(config.jumpLinkNav).hide();
        } else {
            $(config.dropdown).hide();
            $(config.jumpLinkNav).show();
        }

        self.addRemoveSticky();
    };

    JumpLink.prototype.adjustScroll = function (event, element) {
        var targetId = $(element).attr('href');
        var jumpLinkContainerHeight = $(config.jumpLinkNav).outerHeight();
        if ($(config.dropdown).is(':visible')) {
            jumpLinkContainerHeight = $(config.dropdown).outerHeight();
        }
        var topPosition = $(targetId).offset().top - jumpLinkContainerHeight;
        if (!$(config.jumpLinkNav).hasClass(config.stickyClass)) {
            topPosition = topPosition - jumpLinkContainerHeight;
        }
        $('html, body').animate({ scrollTop: topPosition }, 300);
    };

    return JumpLink;
})();

$(document).ready(function () {
    if ($('#jumpLinkContainer').length > 0) {
        var jumpLink = new JumpLink();
        jumpLink.init();
    }
});
